import { ESeverity } from '#shared';

import { getTimeSeverityFromMin } from './getTimeSeverityFromMin';

import type { DutyEvent, MaoCrewDuty } from '#entities';

export const getCrewDutyEvents = (CrewDuties: MaoCrewDuty[]): DutyEvent[] => {
  const now = Date.now();
  const ranges: [
    {
      tz: string;
      unix: number;
    },
    {
      tz: string;
      unix: number;
    },
  ][] = [];
  CrewDuties.forEach((ci, index) => {
    const start = {
      tz: ci.StartAirport.IanaTimeZone,
      unix: ci.OnDutyDateTimeUnix,
    };
    const end = {
      tz: ci.EndAirport.IanaTimeZone,
      unix: ci.OffDutyDateTimeUnix,
    };
    if (!index || ranges[ranges.length - 1][1].unix <= start.unix) {
      ranges.push([start, end]);
    } else {
      ranges[ranges.length - 1][1] = end;
    }
  });

  const result: DutyEvent[] = [];
  if (!ranges[0]) {
    return [
      {
        id: `no-crew`,
        label: 'NO CREW',
        type: 'NoCrew',
        severity: ESeverity.LOW,
      },
    ];
  }

  if (now + 30 * 60 * 1000 < ranges[0][0].unix) {
    result.push({
      id: `no-crew-${now}`,
      startUnix: ranges[0][0].unix,
      startIanaTimezone: ranges[0][0].tz,
      endUnix: ranges[0][1].unix,
      endIanaTimezone: ranges[0][1].tz,
      label: 'NO CREW',
      type: 'NoCrew',
      severity: ESeverity.LOW,
    });
  }
  ranges.forEach(([startUnix, endUnix]) => {
    const severity = getTimeSeverityFromMin((endUnix.unix - now) / 1000 / 60);
    result.push({
      id: `crew-${startUnix.unix}-${endUnix.unix}`,
      label: 'ON DUTY',
      startUnix: startUnix.unix,
      startIanaTimezone: startUnix.tz,
      endUnix: endUnix.unix,
      endIanaTimezone: endUnix.tz,
      type: 'OnDuty',
      severity,
    });
  });
  return result;
};
